import { render, staticRenderFns } from "./2023_618.vue?vue&type=template&id=554bc35a&scoped=true&"
import script from "./2023_618.vue?vue&type=script&lang=js&"
export * from "./2023_618.vue?vue&type=script&lang=js&"
import style0 from "./2023_618.vue?vue&type=style&index=0&id=554bc35a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "554bc35a",
  null
  
)

export default component.exports